import { useMutation } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'

const sendParticipantsTerminated = async ({ data }) => {
  class ApiError extends Error {
    constructor (message, status, data) {
      super(message)
      this.status = status
      this.data = data
    }
  }

  const client = await getApi('sociogram', { authenticated: true })

  try {
    const response = await client.post('/participants-terminateds', data)

    if (response.status === 204) {
      return { success: true, data: null }
    }

    return { success: true, data: response.data }
  } catch (error) {
    throw new ApiError(
      error.message,
      error.response?.status ?? null,
      error.response?.data ?? null
    )
  }
}

export const useSendParticipantsTerminated = () => {
  return useMutation({
    mutationFn: sendParticipantsTerminated
  })
}
